import { render, staticRenderFns } from "./WSK.vue?vue&type=template&id=099fedc3"
import script from "./WSK.vue?vue&type=script&lang=js"
export * from "./WSK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports